<template>
  <div card :class="{ appeared }" class="q" q-card>
    <div card-inner>
      <slot/>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { sizeNames } from '@/utils';

export default {
  name: 'Card',
  data() {
    return {
      appeared: false,
    };
  },
  mounted() {
    let fill = this.$el.getAttribute('data-fill');
    if (!fill) fill = '6,3,2,2';
    const size = {};
    _.forEach(fill.split(','), (s, index) => {
      size[sizeNames[index]] = +s;
    });
    this.$el.size = size;
    this.$nextTick(() => {
      setTimeout(() => { this.appeared = true; }, (this.$el.offsetLeft + this.$el.offsetTop - this.sv) * 0.35);
    });
  },
};
</script>

<style lang="less">
@import "~@/less/proj";

[card] { .pb(20); .-box; .block; .pointer; transition: all 0.3s;
  [card-inner] { transition: all 0.3s; .rel; transform: translateY(30px); opacity: 0; }
  &.appeared [card-inner] {
    transition: all 0.3s ease-in-out;
    transform: translateY(0); opacity: 1;
  }
  .no-touch &:hover [card-inner] {
    transform: translateY(-10px);
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.5);
  }
  &[data-status="up"] { opacity: 0; transform: translateY(-30px); }
  &[data-status="down"] { opacity: 0; transform: translateY(30px); }
}

@media (min-width: @screen-md-min) {
  [card] { .p(0, 9, 18, 9); .ib; .vat;
    [card-holder].wide & { .p(0,18,30,18); }
  }

}

@media (min-width: @screen-lg-min) {
  [card] { .p(0, 15, 30, 15);
    [card-holder].wide & { .p(0,20,30,20); }
  }
}

@media (min-width: @screen-xl-min) {
  [card] { .p(0, 20, 40, 20);
    [card-holder].wide & { .p(0,40,30,40); }
  }
}
</style>
